import './input.scss';

import React from 'react';

import { scrollInputIntoView } from '@/shared/lib/input/decimal';

type InputSize = 'sm' | 'md';

interface InputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | boolean;
  leftAddon?: React.ReactNode;
  suffix?: React.ReactNode;
  rightAddon?: React.ReactNode;
  placeholder?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  align?: 'left' | 'center';
  size?: InputSize;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
  onBlur?: () => void;
}

export const Input: React.FC<InputProps> = ({
  label,
  value,
  onChange,
  error,
  leftAddon,
  suffix,
  rightAddon,
  placeholder,
  inputMode = 'text',
  align = 'left',
  size = 'md',
  disabled,
  ariaLabel,
  className,
  onBlur,
}) => {
  const hasError = !!error;

  return (
    <div className={`field${className ? ` ${className}` : ''}`}>
      {label && <label className="field__label">{label}</label>}
      <div className={`field__input-wrap${size === 'sm' ? ' field__input-wrap--sm' : ''}${hasError ? ' field__input-wrap--error' : ''}`}>
        {leftAddon}
        <input
          type="text"
          inputMode={inputMode}
          className={`field__input${align === 'center' ? ' field__input--center' : ''}`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={scrollInputIntoView}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          aria-label={ariaLabel ?? label}
        />
        {suffix && <span className="field__suffix">{suffix}</span>}
        {rightAddon}
      </div>
      {typeof error === 'string' && error && <p className="field__error">{error}</p>}
    </div>
  );
};
